module.exports = __webpack_public_path__ + "static/media/tradeChart.ec67faac.jpg";